<template>
  <div>
    <div style="w-100">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 1), ActionSetZindexTablaModal(true)"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="recargarTabla()"
        />

        <Button
          :size="15"
          color="#28a745"
          colorText="#ffffff"
          tooltip="Exportar a Excel (Versión Pricing)"
          icon="icon fas fa-file-excel"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 2, 1), ActionSetZindexTablaModal(true)"
          traslate
        />
        <Button v-if="usuarioActual.id_country === 64"
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Exportar a Excel (Versión Chile)"
          icon="icon fas fa-file-excel"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 2, 2), ActionSetZindexTablaModal(true)"
          traslate
        />
      </div>
    </div>
    <ui-modal 
      ref="modal" 
      :title="is_report_filter ? 'Filtros para reporte descuentos cliente' : 'Filtros para tabla descuentos cliente'"
      @close="ActionSetZindexTablaModal(false);"
      size="large"
      > 
      <div class="d-flex flex-column">
        <div class="d-flex">
          <ui-select v-if="this.usuarioActual.id_role !== 3"
            class="w-100 mr-2"
            has-search
            label="Cliente"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="clientes"
            v-model="filtroClienteModel">
          </ui-select>
          <div v-else class="w-100 mr-2"></div>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Naviera"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            multiple
            searchPlaceholder="Buscar"
            :options="navieras"
            v-model="filtroNavieraModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Naviera Salida"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            multiple
            searchPlaceholder="Buscar"
            :options="dataListaNavierasNoUCC"
            v-model="filtroNavieraSalidaModel"
          ></ui-select>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Destino"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            multiple
            searchPlaceholder="Buscar"
            @change="getPODByDestination()"
            :options="destinos"
            v-model="filtroDestinoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="POL"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            multiple
            searchPlaceholder="Buscar"
            v-model="filtroPolModel"
            :options="pol">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="POD"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            multiple
            :options="filtroDestinoModel.length === 0 ? pod : podListByDestination"
            :disabled="podListDisabled"
            searchPlaceholder="Buscar"
            v-model="filtroPodModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <date-picker
            class="w-100 mr-2"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Vigencia"
            v-model="filtroVigenciaModel"
          />
          <date-picker
            class="w-100 ml-1 mr-1"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Desde"
            v-model="filtroDesdeModel"
          />
          <date-picker
            class="w-100 ml-2"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Hasta"
            v-model="filtroHastaModel"
          />
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Producto"
            :options="commodity"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            v-model="filtroProductoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Tipo Contenedor"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            :options="contenedores"
            v-model="filtroTipoContenedorModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Tipo Tarifa"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            :options="tipoContratos"
            searchPlaceholder="Buscar"
            @change="searchContracts()"
            v-model="filtroTipoTarifaModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Nombre Contrato"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            :options="contracts"
            searchPlaceholder="Buscar"
            v-model="filtroNombreContratoModel">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="Gate Out"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ label: 'name', value: 'id' }"
            v-model="filtroGetOutModel"
            :options="[
                {id: 1, name: 'Si'},
                {id: 0, name: 'No'}
                ]">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Trat. frío"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccionar"
            :options="coldtreatmentList"
            searchPlaceholder="Buscar"
            v-model="filtroColdtreatmentModel">
          </ui-select>
        </div>
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-outline-secondary"
            @click="limpiar()"
            style="margin-right: 15px"
          >
            Limpiar
          </button>
          <button
            class="btn btn-outline-primary"
            id="buttonRef"
            @click="is_report_filter ? generarReporte() : filtrar()"
          >
            Filtrar
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiModal from "keen-ui/src/UiModal";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

import Button from "../../../common/Button";
import { mapActions, mapState } from "vuex";
import {
  getDescuentosClientesFiltros,
  getDescuentosClientes,
  getContratosPorNavieraYTipo,
  downloadReporteDescuentosClientes,
  getPODByDestination, getListasAcuerdosBase
} from "../../../../constants/lineas";

export default {
  props: ["data", "dataInicial", "getListaDescuentosClientes"],
  data() {
    return {
      filtroClienteModel: [],
      filtroNavieraModel: [],
      filtroNavieraSalidaModel: [],
      filtroPolModel: [],
      filtroPodModel: [],
      filtroDestinoModel: [],
      filtroTipoContenedorModel: "",
      filtroProductoModel: [],
      filtroDesdeModel: "",
      filtroHastaModel: "",
      filtroVigenciaModel: "",
      filtroTipoTarifaModel: "",
      filtroNombreContratoModel: "",
      filtroGetOutModel: "",
      filtroColdtreatmentModel: "",
      dataAux: this.data,
      contracts: [],
      is_report_filter: false,
      report_version: 1,
      coldtreatmentList: [],
      podListByDestination: [],
      podListDisabled: false
    };
  },
  components: {
    UiSelect,
    Button,
    UiModal,
    DatePicker
  },
  computed: {
    ...mapState([
      "contratos",
      "clientes",
      "navieras",
      "pol",
      "pod",
      "destinos",
      "commodity",
      "tipoContratos",
      "contenedores",
      "usuarioActual"
    ]),
    ...mapState("lineas", [
      "dataContenedores",
      "dataListaNavierasNoUCC"
    ])
  },

  methods: {
    ...mapActions([
      "ActionSetShowDescuentosClientes",
      "ActionSetZindexTablaModal"
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasDescuentosClientes"
    ]),
    async getPODByDestination() {

      if (this.filtroDestinoModel.length > 0) {

        this.podListDisabled = true;

        this.filtroPodModel = [];

        this.podListByDestination = await getPODByDestination({ "destinations": this.filtroDestinoModel.map(d => +d.id) ?? [] });

        this.podListDisabled = false;

      }

    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    limpiar() {
      this.filtroClienteModel = [];
      this.filtroNavieraModel = [];
      this.filtroNavieraSalidaModel = [];
      this.filtroPolModel = [];
      this.filtroPodModel = [];
      this.podListByDestination = [];
      this.filtroDestinoModel = [];
      this.filtroTipoContenedorModel = {};
      this.filtroProductoModel = [];
      this.filtroDesdeModel = "";
      this.filtroHastaModel = "";
      this.filtroVigenciaModel = "";
      this.filtroTipoTarifaModel = {};
      this.filtroNombreContratoModel = {};
      this.filtroGetOutModel = "";
      this.filtroColdtreatmentModel = "";
    },

    async searchContracts(){

      const form = { type: +this.filtroTipoTarifaModel.id } ;

      this.contracts = await getContratosPorNavieraYTipo( form );
    },

    async recargarTabla(){

      
      this.limpiar();
      this.$vToastify.loader("Recargando Tabla...");

      // await this.actionSetDataListarTarifasDescuentosClientes([]);
      const { data_table } = await getDescuentosClientes();

      await this.actionSetDataListarTarifasDescuentosClientes( data_table );

      this.$vToastify.stopLoader();

    },
    async filtrar() {

      this.ActionSetShowDescuentosClientes(true);

      const form = {
        client_id: this.usuarioActual.id_role == 3
          ? [+this.usuarioActual.id_cliente]
          : (this.filtroClienteModel.id ? [this.filtroClienteModel.id] : []),
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => +n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.map(d => +d.id) ?? [],
        products_category_id: this.filtroProductoModel.id ? [this.filtroProductoModel.id] : [],
        from_date: this.filtroDesdeModel,
        to_date: this.filtroHastaModel,
        vigency: this.filtroVigenciaModel,
        type: this.filtroTipoTarifaModel.id ?? null,
        contract_id: this.filtroNombreContratoModel.id ?? null,
        container_id: this.filtroTipoContenedorModel.id ?? null,
        get_out: this.filtroGetOutModel.id ?? null,
        coldtreatment_id: this.filtroColdtreatmentModel.id ?? null
      };

      this.estadoButton("Filtrando...");

      this.$vToastify.loader("Filtrando...");

      try {

        await this.actionSetDataListarTarifasDescuentosClientes([]);

        const { data_table } = await getDescuentosClientesFiltros( form );

        await this.actionSetDataListarTarifasDescuentosClientes( data_table );

        this.$vToastify.stopLoader();

        this.estadoButton("Filtrar", false);

        this.closeModal("modal");

      } catch (error) {

        this.$vToastify.stopLoader();

        this.estadoButton("Filtrar", false);

        return this.$vToastify.error(
          "Por favor, intente filtrar de una forma más precisa sus datos para un mejor resultado, si el problema persiste, recargue la página e intente nuevamente.",
          "¡Error al filtrar datos!"
        );
      }
    },

    async generarReporte() {

      let filters = {
        client_id: this.usuarioActual.id_role == 3
          ? [+this.usuarioActual.id_cliente]
          : (this.filtroClienteModel.id ? [this.filtroClienteModel.id] : []),
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => +n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.map(d => +d.id) ?? [],
        products_category_id: this.filtroProductoModel.id ? [this.filtroProductoModel.id] : [],
        from_date: this.filtroDesdeModel,
        to_date: this.filtroHastaModel,
        vigency: this.filtroVigenciaModel,
        type: this.filtroTipoTarifaModel.id ?? null,
        contract_id: this.filtroNombreContratoModel.id ?? null,
        container_id: this.filtroTipoContenedorModel.id ?? null,
        get_out: this.filtroGetOutModel.id ?? null,
        coldtreatment: this.filtroColdtreatmentModel.name ?? null,
        version: this.report_version
      };

      this.estadoButton("Generando reporte...");

      this.$vToastify.loader("Generando reporte...");

      try {

        await downloadReporteDescuentosClientes( filters );

        this.$vToastify.stopLoader();

        this.$vToastify.info(
          "Cuando el informe esté disponible será enviado a su correo, esto puede tardar algunos minutos",
          "¡Generando informe!"
        );

        this.estadoButton("Generar reporte", false);

        this.closeModal("modal");

      } catch (error) {

        this.$vToastify.stopLoader();

        this.estadoButton("Generar reporte");

        return this.$vToastify.error(
          "Por favor, intente filtrar de una forma más precisa sus datos para un mejor resultado, si el problema persiste, recargue la página e intente nuevamente.",
          "¡Error al filtrar datos para reporte!"
        );

      }
    },

    openModal(ref, type, version = 1) {
      if (type !== 1) {

        this.estadoButton("Generar reporte", false);

        this.report_version = version;

        this.is_report_filter = true;

      } else {

        this.estadoButton("Filtrar", false);

        this.is_report_filter = false;

      }

      this.ActionSetZindexTablaModal(true);

      this.$refs[ref].open();
    },
    closeModal(ref) {

      this.$refs[ref].close();

      this.is_report_filter = false;

      this.estadoButton("Filtrar", false);

    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
  },
  async created(){
    const { lista_coldtreatment } = await getListasAcuerdosBase();
    this.coldtreatmentList = lista_coldtreatment || [];
  }
};
</script>

<style>
.mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}
</style>
